import React from "react";
import { Loading } from "src/components/Feedback/Loading";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import { useOrgConfig } from "src/hooks/useOrgConfig";
import { Branding, DefaultBranding } from "src/schemas/Branding";
import * as RD from "src/types/remoteData";
import { BrandedChakraProvider } from "./BrandedChakraProvider";

export type BrandingContextType = RD.RemoteData<unknown, Branding | null>;

const BrandingContext = React.createContext<BrandingContextType>(RD.notAsked());

export function BrandingProvider({ children }: React.PropsWithChildren<{}>) {
  const branding = useOrgConfig<OrgConfig.BrandingConfig>(
    "Branding",
    DefaultBranding
  );

  return (
    <BrandingContext.Provider value={branding}>
      {branding.isLoading() && !branding.hasData() ? (
        <BrandedChakraProvider>
          <Loading />
        </BrandedChakraProvider>
      ) : (
        children
      )}
    </BrandingContext.Provider>
  );
}

export function useBranding(): Branding {
  const context = React.useContext(BrandingContext);
  if (context === undefined) {
    console.error("useBranding() must be used within a BrandingProvider");
  }

  return (
    context.withDefault(DefaultBranding) ?? {
      ...DefaultBranding,
      name: "Default",
    }
  );
}
